import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}

const RU_MONTHS = [
  'января', 'февраля', 'марта', 'апреля', 'мая', 'июня',
  'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря',
]

/** «14 августа 2026» — без завязки на локаль браузера. */
export function formatDate(value: string | Date | null | undefined): string {
  if (!value) return ''
  const date = typeof value === 'string' ? new Date(value) : value
  if (Number.isNaN(date.getTime())) return ''
  return `${date.getDate()} ${RU_MONTHS[date.getMonth()]} ${date.getFullYear()}`
}

/** «14:05» — время сообщения в ленте чата. */
export function formatTime(value: string | Date): string {
  const date = typeof value === 'string' ? new Date(value) : value
  if (Number.isNaN(date.getTime())) return ''
  return `${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`
}

/** «Сегодня» / «Вчера» / дата — для списка диалогов и заметок. */
export function formatRelativeDay(value: string | Date): string {
  const date = typeof value === 'string' ? new Date(value) : value
  if (Number.isNaN(date.getTime())) return ''

  const startOfDay = (d: Date) => new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime()
  const days = Math.round((startOfDay(new Date()) - startOfDay(date)) / 86_400_000)

  if (days === 0) return formatTime(date)
  if (days === 1) return 'Вчера'
  if (days < 7) return `${days} дн. назад`
  return formatDate(date)
}

/**
 * Русская плюрализация: plural(3, 'сообщение', 'сообщения', 'сообщений').
 * Ленты вида «осталось 2 сообщения» без неё читаются как машинный перевод.
 */
export function plural(count: number, one: string, few: string, many: string): string {
  const mod10 = count % 10
  const mod100 = count % 100

  if (mod10 === 1 && mod100 !== 11) return one
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return few
  return many
}

export function pluralize(count: number, one: string, few: string, many: string): string {
  return `${count} ${plural(count, one, few, many)}`
}

/** Инициалы для аватара: «Алексей Белезеков» → «АБ», иначе первая буква email. */
export function initialsOf(name: string | null | undefined, email?: string): string {
  const source = (name ?? '').trim()
  if (source) {
    const parts = source.split(/\s+/).slice(0, 2)
    return parts.map((p) => p[0]?.toUpperCase() ?? '').join('')
  }
  return (email?.[0] ?? '?').toUpperCase()
}
